import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgIf } from '@angular/common';

import { PodcastsService } from '../../../../shared/services/podcasts.service';

@Component({
    selector: 'app-player-podcast',
    templateUrl: './player-podcast.component.html',
    styleUrls: ['./player-podcast.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class PlayerPodcastComponent implements OnInit {

    state: number = 0; // 0 = central, 1 = canto, 2 = minimizado, 3 = fechado
    currentPodcast = null;

    @ViewChild('audioPlayer') audioPlayerRef!: ElementRef<HTMLAudioElement>;

    constructor(private podcastsService: PodcastsService) {}

    ngOnInit(): void {
        this.podcastsService.podcastIndex$.subscribe(podcast => {
            if (podcast !== null && podcast) {
                this.currentPodcast = podcast;
                this.setState(0);
                setTimeout(() => {
                    const audio = this.audioPlayerRef?.nativeElement;
                    if (audio) {
                        audio.pause();
                        audio.load();
                        audio.play();
                    }
                }, 100);
            }
        });
    }

    setState(newState: number): void {
        this.state = newState;
        document.body.classList.remove('podcast-central');
        if (this.state === 0) {
            document.body.classList.add('podcast-central');
        }
    }

    toggleState(): void {
        if (this.state === 0) {
            this.setState(1);
        } else if (this.state === 1) {
            this.setState(2);
        }
    }

    isVisible(): boolean {
        return this.state !== 3;
    }

    isMinimized(): boolean {
        return this.state === 2;
    }

    isCorner(): boolean {
        return this.state === 1;
    }
}
